import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const REGISTER_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('registerEnabled', {
  factory: () => true
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const REGISTER_INTRO_BANNER_ID: InjectionToken<string | undefined> = new InjectionToken<string | undefined>(
  'registerIntroBannerId',
  {
    factory: () => undefined
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const REGISTER_INTRO_FORCE_REGISTER_SELECTION: InjectionToken<boolean> = new InjectionToken<boolean>(
  'registerIntroForceRegisterSelection',
  {
    factory: () => false
  }
);
